import { trackGtm, trackYouLeadEvent } from "./track-event"

document.addEventListener("DOMContentLoaded", () => {
  const gtmNewProductsListEvent = new GtmNewProductsListEvent()
  gtmNewProductsListEvent.fireEventOnSubmit()
})

class GtmNewProductsListEvent {
  SUBMIT_EVENT_NAME = "new-products-list"

  constructor() {
    this.configurator = document.querySelector("#configurator")
  }

  fireEventOnSubmit() {
    if (!this.configurator) {
      return
    }

    this.form = this.configurator.querySelector("#new_front_order_line_item")
    this.saveButton = this.configurator.querySelector("#save_config_button")

    this.saveButton.addEventListener("click", () => {
      if (this.configurator.dataset.newList !== undefined) {
        trackGtm(this.SUBMIT_EVENT_NAME)
        trackYouLeadEvent(this.SUBMIT_EVENT_NAME)
      }
    })
  }
}
